import { Box } from "@mui/material";
import CompareTableHeader from "./compareTableHeader";
import cssVars from "../../styles/vars.module.scss"
import CompareTableBody from "./compareTableBody";
import { useRef } from "react";


const CompareTable = () => {

    const ref = useRef()

    return (
        <Box
            ref={ref}
            sx={{
                width: "100%", overflowX: "auto",
                "&::-webkit-scrollbar": { height: 8 },
                "&::-webkit-scrollbar-track": { background: '#F6F6F6' },
                "&::-webkit-scrollbar-thumb": { background: cssVars.gray, borderRadius: 20 },
                pb: "24px !important"
            }}>
            <CompareTableHeader parentRef={ref} />
            <CompareTableBody parentRef={ref} />
        </Box>

    );
}

export default CompareTable;